import React from 'react';
import { Play, TrendingUp, Trophy } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';

const Tutorials = () => {
  const levels = [
    {
      title: 'Niveau Débutant',
      icon: <Play size={32} />,
      badgeColor: 'bg-green-500',
      description: 'Tes premiers pas dans Scratch ! Découvre les blocs de base, crée ton premier personnage et fais-le bouger.',
      topics: [
        'Découvrir l\'interface Scratch',
        'Faire bouger un sprite',
        'Ajouter des sons',
        'Créer ton premier jeu simple'
      ],
      buttonText: 'Commencer',
      buttonClass: 'bg-green-500 hover:bg-green-600'
    },
    {
      title: 'Niveau Intermédiaire',
      icon: <TrendingUp size={32} />,
      badgeColor: 'bg-yellow-500',
      description: 'Tu maîtrises les bases ? Super ! Apprends les boucles, les conditions et crée des jeux plus complexes.',
      topics: [
        'Utiliser les boucles',
        'Comprendre les conditions',
        'Créer des variables',
        'Faire interagir plusieurs sprites'
      ],
      buttonText: 'Continuer',
      buttonClass: 'bg-yellow-500 hover:bg-yellow-600'
    },
    {
      title: 'Niveau Avancé',
      icon: <Trophy size={32} />,
      badgeColor: 'bg-red-500',
      description: 'Deviens un expert Scratch ! Maîtrise les listes, les clones et crée des projets impressionnants.',
      topics: [
        'Travailler avec les listes',
        'Utiliser les clones',
        'Créer tes propres blocs',
        'Projets avancés multijoueurs'
      ],
      buttonText: 'Relever le défi',
      buttonClass: 'bg-red-500 hover:bg-red-600'
    }
  ];

  return (
    <section id="tutoriels" className="py-20 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="section-title">Nos Tutoriels Scratch</h2>
        <p className="text-center text-xl text-[#6C757D] mb-16 max-w-3xl mx-auto">
          Apprends à programmer étape par étape, quel que soit ton niveau !
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {levels.map((level, index) => (
            <Card key={index} className="tutorial-card hover:shadow-xl transition-all duration-300 border-2">
              <CardHeader>
                <div className="flex justify-center mb-4">
                  <Badge className={`${level.badgeColor} text-white px-4 py-2 text-lg`}>
                    {level.icon}
                  </Badge>
                </div>
                <CardTitle className="text-2xl text-center mb-2">{level.title}</CardTitle>
                <CardDescription className="text-base text-center">
                  {level.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <ul className="space-y-3 mb-6">
                  {level.topics.map((topic, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="text-[#0FBD8C] mr-2 text-xl">✓</span>
                      <span className="text-[#2C3E50]">{topic}</span>
                    </li>
                  ))}
                </ul>
                <Button className={`w-full ${level.buttonClass} text-white font-semibold`}>
                  {level.buttonText}
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Tutorials;